var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-stepper-content',{staticClass:"pa-0",attrs:{"step":_vm.step}},[_c('AsiFadeTransition',[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"absolute":"","indeterminate":""}})],1),_c('div',{class:{'ma-6': !_vm.unwrapped}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }